import { stats_constants } from "./constants";

const Stats = () => {
  return (
    <section className="relative py-4 md:py-10 overflow-hidden border border-[#B6E4FF]">
      <div className="absolute inset-0 bg-[#084DC5]" />

      <div className="absolute inset-0">
        <img
          src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204906/powerdbyai/numbersLine_pattern2_bkxjjx.png"
          alt=""
          className="absolute right-5 top-20 md:right-0 md:top-0"
        />
        <img
          src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755204905/powerdbyai/numbers_line_pattern_1_ilxvia.png"
          alt=""
          className="absolute bottom-20 md:left-0 md:bottom-0"
        />
      </div>

      <div className="relative  w-full max-w-[984px]  mx-auto px-4">
        <div className="md:min-h-[178px] grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {stats_constants.map((stat, index) => (
            <div
              key={index}
              className={`text-white md:border-r ${
                index === 1 ? "border-r-transparent" : "border-r-[#B6E4FF]"
              } space-y-2`}
            >
              <h3 className="text-[32px]  text-center lg:text-left lg:text-[64px] font-bold leading-none">
                {stat.number}
              </h3>
              <p className="text-center lg:text-left text-[10px] lg:text-xl">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
